import { CustomChartController } from './chart-controller';

export default function CustomChartTitle({
  chartInfo,
}: {
  chartInfo: ChartContextProps;
}) {
  return (
    <div className="flex items-center justify-between">
      <h3 className="text-2xl font-semibold">Custom chart</h3>
      <CustomChartController chartInfo={chartInfo} />
    </div>
  );
}
